module.exports = __webpack_public_path__ + "9e338876783991ac58ef3d234d3d0ce9.svg";